import { caseJSONToText } from '../pages/chat/helpers';
import { CaseDraft } from '../store/types';

export const caseCreatedText = (caseId: number) => `Case created successfully. Case id: ${caseId}`;

export const unauthorizedErrorText = 'Session expired or not logged in.';

export const sessionExpiredInfoText =
  'Your previous chat session expired. I no longer have the previous conversation context.\n\n';

export const forbiddenErrorText =
  'Access denied. Only Synergi Life users can access this application.';

export const rateLimitText = 'SL AI is under too heavy load. Please try again.';

export const genericCaseErrorText = 'Failed to create a case. Please try again.';

export const validationSendCaseErrorText = 'Failed to send a case:\n';

export const genericErrorText =
  'Synergi Life AI features are not available right now. Please try again later.';

export const caseRegistrationConfirmationText = (
  caseContent: CaseDraft,
  fieldLabels?: Record<string, string>
) =>
  `This is a case that I can register in Synergi Life for you: ${caseJSONToText(caseContent, fieldLabels)} \n\nIs it correct?`;
